define('features/overlayGameLauncher/adventureTwo/debugCommands/debugCommandsInit',[],function () {

    return function AdventureTwoDebugCommanfsInit (AddVirtualCurrencyCommand,
                                                   AddXpCommand,
                                                   adventureTwoObservableData) {
        var self = this;

        self.init = function (player) {

            adventureTwoObservableData.property('debugCommands')({
                addGems: function (gems) {
                    return new AddVirtualCurrencyCommand({
                        playerId: player.id,
                        gems: gems
                    }).dispatch();
                },
                addXP: function (xp) {
                    return new AddXpCommand({
                        playerId: player.id,
                        xp: xp
                    }).dispatch();
                }
            });
        };
    };

});

